import { Component } from "react";
import HeadCustomer from "../components/headcustomer";

class Header extends Component {
    constructor(props){
        super(props)
    }
    render(){
        return(
            <>
                <HeadCustomer />
            </>
        )
    }
}
export default Header;